import React from "react";
import Profile from "../views/Profile"; // your existing profile component

export const ProfilePage = () => {
  return (
    <div style={{ padding: "2rem" }}>
      <Profile />
    </div>
  );
};


